import { memo } from 'react';
import { Streamdown } from 'streamdown';

interface ResponseProps {
  /**
   * Markdown content to render
   */
  children: string;

  /**
   * Parse incomplete markdown during streaming
   * @default false
   */
  parseIncompleteMarkdown?: boolean;
}

/**
 * Response Component
 *
 * Renders markdown content with enhanced formatting support for:
 * - Tables
 * - Code blocks with syntax highlighting
 * - Math equations
 * - Lists, blockquotes, headers
 * - Smart streaming support with incomplete markdown parsing
 *
 * Based on AI SDK Elements Response component.
 * Uses streamdown library for markdown rendering.
 */
export const Response = memo(function Response({
  children,
  parseIncompleteMarkdown = false,
}: ResponseProps) {
  return (
    <div className="response-container overflow-hidden max-w-full [&_.min-w-full]:min-w-0">
      <Streamdown parseIncompleteMarkdown={parseIncompleteMarkdown}>
        {children}
      </Streamdown>
    </div>
  );
});
